import { render } from "./GlobalMapTop.vue?vue&type=template&id=e370d288"
import script from "./GlobalMapTop.vue?vue&type=script&lang=js"
export * from "./GlobalMapTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__